export class ManfrediteOfferFilterResponse {
    static _OPENAPI_METADATA_FACTORY() {
        return { id: { required: true, type: () => String }, createdAt: { required: true, type: () => Date }, manfrediteId: { required: true, type: () => Number }, criteria: { required: true, type: () => require("./manfredite-offer-filter.response").ManfrediteOfferFilterResponseCriteria } };
    }
}
export class ManfrediteOfferFilterResponseCriteria {
    constructor() {
        this.remoteOptions = [];
        this.techs = [];
        this.techRoles = [];
        this.minLanguages = [];
        this.locations = [];
    }
    static _OPENAPI_METADATA_FACTORY() {
        return { minSalary: { required: false, type: () => Number }, currency: { required: false, type: () => String }, offerLanguage: { required: false, type: () => String }, text: { required: false, type: () => String }, remoteOptions: { required: true, type: () => [Object] }, techs: { required: true, type: () => [require("../manfredite/techs/tech-summary").TechSummary] }, techRoles: { required: true, type: () => [require("../manfredite/roles/role-summary").RoleSummary] }, minLanguages: { required: true, type: () => [require("../manfredite/languages/language.response").LanguageResponse] }, locations: { required: true, type: () => [require("../manfredite/locations/location").Location] } };
    }
}
export const ManfrediteOfferFilterResponseRemoteOptionsValues = ['remote', 'hybrid', 'face-to-face'];
//# sourceMappingURL=manfredite-offer-filter.response.js.map